import "./assets/css/main.css";
import "./assets/css/override.css";
import "primeicons/primeicons.css";
import { createApp } from "vue";
import PrimeVue from "primevue/config";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { awsConfig } from "@/services/constant-services";
import { Amplify } from "aws-amplify";
import { ToastService } from "primevue";
import Tooltip from "primevue/tooltip";
import { configurePassiveEventListeners } from "@/utils/event-listeners";

Amplify.configure(awsConfig);

// Configure passive event listeners
configurePassiveEventListeners();

// Global error handler for unhandled promise rejections and errors
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  if (event.reason?.message?.includes('Cannot read properties of null')) {
    console.warn('Suppressing null property access error during logout/cleanup');
    event.preventDefault();
  }
});

window.addEventListener('error', (event) => {
  if (event.error?.message?.includes('Cannot read properties of null')) {
    console.warn('Suppressing null property access error during logout/cleanup');
    event.preventDefault();
  }
});

const app = createApp(App);
const pinia = createPinia();

// Add Vue error handler to catch setAttribute and emitsOptions errors
app.config.errorHandler = (err, instance, info) => {
  // Log detailed error information for debugging
  console.error('Vue error caught:', {
    message: err?.message,
    stack: err?.stack,
    info: info,
    component: instance?.$options?.name || instance?.$options?.__name,
    props: instance?.$props
  });

  // Suppress specific errors that occur during production builds
  if (err?.message?.includes('setAttribute') ||
      err?.message?.includes('emitsOptions') ||
      err?.message?.includes('Cannot convert object to primitive')) {
    console.warn('Suppressed Vue prop/attribute error:', err.message);
    // Don't re-throw - just suppress
    return;
  }

  // For other errors, log but don't break the app
  console.error('Unhandled Vue error:', err);
};

app.use(PrimeVue);
app.use(pinia);
app.use(router);
app.use(ToastService);
app.directive("tooltip", Tooltip);
app.mount("#app");
